export function AddGoogleAds() {
  
    gtag('consent', 'update', {
      'ad_storage': 'granted'
    });

    
  
}
